import { render, staticRenderFns } from "./Watson.vue?vue&type=template&id=ad9f415e&scoped=true&"
import script from "./Watson.vue?vue&type=script&lang=js&"
export * from "./Watson.vue?vue&type=script&lang=js&"
import style0 from "./Watson.vue?vue&type=style&index=0&id=ad9f415e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9f415e",
  null
  
)

export default component.exports